import { useTranslation } from "react-i18next";
import { mainSiteUrl } from "@/mocks/categories";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20with%20warm%20terracotta%20and%20soft%20sand%20tones%2C%20carefully%20arranged%20streetwear%20collection%20on%20a%20rustic%20wooden%20surface%20near%20sunlit%20window%2C%20natural%20morning%20light%20casting%20gentle%20shadows%2C%20ivy%20plants%20adding%20organic%20greenery%20touch%2C%20relaxed%20Mediterranean%20villa%20aesthetic%2C%20clean%20modern%20fashion%20magazine%20style%2C%20high%20detail%20fabric%20textures%20visible%20on%20cotton%20and%20denim%20materials%2C%20sophisticated%20yet%20approachable%20atmosphere%2C%20subtle%20depth%20of%20field%20with%20bokeh%20background&width=1600&height=900&seq=hero-bg-2026-v2&orientation=landscape"
          alt="Kakobuy Spreadsheet - moda i styl"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full border border-white/30 text-white/90 text-xs font-medium mb-6 whitespace-nowrap">
              #1 Kakobuy Spreadsheet w Polsce
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-extrabold text-white leading-[1.1] mb-5">
              {t("hero.tagline")}
            </h1>
            <p className="text-white/80 text-base md:text-lg max-w-lg mx-auto lg:mx-0 mb-8 leading-relaxed">
              {t("hero.subtitle")}
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
              >
                {t("hero.ctaPrimary")}
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 border-2 border-white/60 text-white rounded-full text-sm font-semibold hover:bg-white hover:text-foreground-950 transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
              >
                {t("hero.ctaSecondary")}
                <i className="ri-shopping-bag-line"></i>
              </a>
            </div>

            <div className="flex items-center gap-8 mt-10 justify-center lg:justify-start">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-extrabold text-white">
                  {t("hero.stats.products")}
                </div>
                <div className="text-white/60 text-xs mt-1">{t("hero.stats.productsLabel")}</div>
              </div>
              <div className="w-px h-10 bg-white/20"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-extrabold text-white">
                  {t("hero.stats.free")}
                </div>
                <div className="text-white/60 text-xs mt-1">{t("hero.stats.freeLabel")}</div>
              </div>
              <div className="w-px h-10 bg-white/20"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-extrabold text-white">
                  {t("hero.stats.verified")}
                </div>
                <div className="text-white/60 text-xs mt-1">{t("hero.stats.verifiedLabel")}</div>
              </div>
            </div>
          </div>

          <div className="hidden lg:flex flex-1 gap-4 justify-center">
            <div className="flex flex-col gap-4">
              <div className="w-[180px] h-[220px] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Close%20up%20editorial%20photography%20of%20premium%20chunky%20sneakers%20with%20visible%20texture%20details%20on%20polished%20concrete%20floor%2C%20warm%20morning%20sunlight%20streaming%20from%20left%20side%20creating%20dramatic%20shadows%2C%20sneakers%20in%20rich%20olive%20green%20suede%20and%20cream%20leather%20combination%2C%20luxury%20streetwear%20catalog%20style%2C%20sharp%20focus%20on%20material%20quality%20stitching%20and%20sole%20details%2C%20industrial%20loft%20setting%20with%20exposed%20brick%20wall%20in%20soft%20focus%20background&width=400&height=500&seq=hero-img-01-v2&orientation=portrait"
                  alt="Premium sneakers"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="w-[180px] h-[180px] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20photography%20of%20a%20heavyweight%20cotton%20hoodie%20in%20warm%20charcoal%20grey%20neatly%20folded%20on%20light%20oak%20parquet%20flooring%2C%20soft%20diffused%20afternoon%20light%20from%20large%20windows%20creating%20gentle%20atmosphere%2C%20cozy%20textural%20contrast%20between%20knitted%20fabric%20and%20wood%20grain%2C%20Scandinavian%20interior%20design%20aesthetic%2C%20clean%20editorial%20composition%20with%20negative%20space%20around%20garment%2C%20lifestyle%20fashion%20catalog%20feel&width=400&height=400&seq=hero-img-02-v2&orientation=squarish"
                  alt="Stylish hoodie"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div className="flex flex-col gap-4 mt-8">
              <div className="w-[200px] h-[160px] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Artfully%20arranged%20fashion%20accessories%20including%20tortoiseshell%20sunglasses%20leather%20wallet%20and%20woven%20bracelet%20on%20a%20warm%20terracotta%20ceramic%20tray%2C%20soft%20golden%20afternoon%20light%20streaming%20through%20sheer%20linen%20curtains%2C%20rich%20amber%20umber%20and%20cognac%20tones%2C%20editorial%20still%20life%20photography%20with%20Mediterranean%20summer%20villa%20mood%2C%20high%20detail%20on%20material%20textures%20leather%20grain%20and%20woven%20patterns%2C%20elegant%20travel%20lifestyle%20aesthetic&width=450&height=350&seq=hero-img-03-v2&orientation=landscape"
                  alt="Fashion accessories"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="w-[200px] h-[240px] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20lightweight%20jacket%20in%20muted%20sage%20green%20draped%20over%20a%20mid%20century%20modern%20wooden%20chair%2C%20warm%20afternoon%20sunlight%20filtering%20through%20venetian%20blinds%20creating%20stripe%20shadows%2C%20contemporary%20apartment%20interior%20with%20white%20walls%20and%20natural%20textures%2C%20sophisticated%20editorial%20fashion%20photography%2C%20airy%20and%20refined%20atmosphere%20with%20dust%20motes%20visible%20in%20sunbeams%2C%20premium%20catalog%20aesthetic&width=450&height=550&seq=hero-img-04-v2&orientation=portrait"
                  alt="Stylish jacket"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}